import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TemplateListItem = ({ template, isSelected, onSelect, onPreview }) => {
  return (
    <div
      className={`p-3 md:p-4 rounded-lg border transition-all duration-250 ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-warm-sm'
          : 'border-border bg-card hover:border-primary/30'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 text-right">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="text-sm md:text-base font-heading font-semibold text-foreground">
              {template?.name}
            </h4>
            {template?.isNew && (
              <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent text-accent-foreground">
                جديد
              </span>
            )}
          </div>
          <p className="text-xs md:text-sm text-muted-foreground mb-2 line-clamp-2">
            {template?.description}
          </p>
          <div className="flex items-center gap-3 text-xs">
            <span className="text-muted-foreground flex items-center gap-1">
              <Icon name="FileText" size={14} />
              {template?.pageCount} صفحة
            </span>
            <span className="text-muted-foreground flex items-center gap-1">
              <Icon name="Clock" size={14} />
              آخر تحديث: {template?.lastUpdated}
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Button
            variant={isSelected ? 'default' : 'outline'}
            size="xs"
            onClick={onSelect}
            iconName={isSelected ? 'Check' : 'FileText'}
            iconSize={14}
          >
            {isSelected ? 'محدد' : 'اختيار'}
          </Button>
          <Button
            variant="ghost"
            size="xs"
            onClick={onPreview}
            iconName="Eye"
            iconSize={14}
          >
            معاينة
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplateListItem;